<div *ngIf="isLoading">
  <app-loading-spinner></app-loading-spinner>
</div>

<!-- Default form register -->

<div
  mdbModal
  #frame="mdbModal"
  class="modal fade top"
  id="frameModalTop"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-notify modal-success" role="document">
    <!--Content-->
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header">
        <p class="heading lead">Modal Success</p>

        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="frame.hide()"
        >
          <span aria-hidden="true" class="white-text">&times;</span>
        </button>
      </div>

      <!--Body-->
      <div class="modal-body">
        <div class="text-center">
          <mdb-icon
            fas
            icon="check"
            size="4x"
            class="mb-3 animated rotateIn"
          ></mdb-icon>
          <p>
            User registration complete :)
          </p>
        </div>
      </div>

      <!--Footer-->
      <div class="modal-footer justify-content-center">
        <a
          type="button"
          mdbBtn
          color="success"
          class="waves-effect"
          mdbWavesEffect
          >SAVE
          <mdb-icon far icon="gem" class="ml-1"></mdb-icon>
        </a>
        <a
          type="button"
          mdbBtn
          color="success"
          outline="true"
          class="waves-effect"
          mdbWavesEffect
          (click)="frame.hide()"
          >No, thanks</a
        >
      </div>
    </div>
    <!--/.Content-->
  </div>
</div>

<form
  *ngIf="!isLoading"
  #RegisterForm="ngForm"
  (ngSubmit)="addUser(RegisterForm)"
  [formGroup]="validatingForm"
  class="text-center border border-light p-5 col-md-8"
  style="margin: 0 auto;"
>
  <p class="h4 mb-4">Sign up</p>

  <div class="form-row mb-4">
    <div class="col">
      <!-- First name -->
      <input
        type="text"
        id="defaultRegisterFormFirstName"
        formControlName="firstName"
        class="form-control"
        placeholder="First name"
      />
    </div>
    <div class="col">
      <!-- Last name -->
      <input
        type="text"
        id="defaultRegisterFormLastName"
        formControlName="lastName"
        class="form-control"
        placeholder="Last name"
      />
    </div>
  </div>

  <!-- E-mail -->
  <input
    type="email"
    id="defaultRegisterFormEmail"
    formControlName="email"
    class="form-control mb-4"
    placeholder="E-mail"
  />

  <!-- Password -->
  <input
    [type]="ShowPassword ? 'text' : 'password'"
    id="defaultRegisterFormPassword"
    formControlName="password"
    class="form-control"
    placeholder="Password"
    aria-describedby="defaultRegisterFormPasswordHelpBlock"
  />
  <p (click)="toggleEye()">
    <i [class]="ShowPassword ? 'fa-eye far' : 'fa-eye-slash far'"></i>
  </p>
  <small
    id="defaultRegisterFormPasswordHelpBlock"
    class="form-text text-muted mb-4"
  >
    At least 8 characters and 1 digit
  </small>
  <input
    type="password"
    id="confirmPassword"
    class="form-control"
    placeholder="confirm Password"
    aria-describedby="defaultRegisterFormPasswordHelpBlock"
  />

  <!-- E-mail -->
  <label for="avatar">Upload your avatar</label>
  <input
    type="file"
    id="avatar"
    formControlName="avatar"
    placeholder="Upload your avatar"
    class="form-control mb-4"
  />
  <p class="alert alert-info " *ngIf="errMessage">
    {{ errMessage }}
  </p>
  <!-- Sign up button -->
  <button
    type="button"
    mdbBtn
    rounded="true"
    data-toggle="modal"
    data-target="#basicExample"
    (click)="frame.show()"
    mdbWavesEffect
    mdbBtn
    color="danger"
    block="true"
    class="my-4"
    type="submit"
    [disabled]="!RegisterForm.valid"
  >
    Sign Up
  </button>

  <!-- Social register -->
  <p>or sign up with:</p>

  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="facebook"></mdb-icon>
  </a>
  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="twitter"></mdb-icon>
  </a>
  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="linkedin"></mdb-icon>
  </a>
  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="github"></mdb-icon>
  </a>
</form>

<!-- Default form register -->
